import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "tw-text-body-2 tw-min-h-[52px] tw-px-2 tw-py-2.5 tw-text-secondary" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("li", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
    ]));
}
